export var themes = {
  default: 'default',
  added: 'added',
  add: 'add',
  edit: 'edit'
};